<div mat-dialog-title>
	Requeue message
</div>

<mat-dialog-content>
	<p class="text-muted mb-3">
		<strong>{{ message.templateName }}</strong> to {{ message.toAddress }}
		(currently {{ message.status }}).
	</p>

	<div class="form-check mb-2">
		<input class="form-check-input" type="radio" id="requeue-send"
			name="targetMode" value="Send" [(ngModel)]="targetMode">
		<label class="form-check-label" for="requeue-send">Send now</label>
	</div>
	<div class="form-check mb-2">
		<input class="form-check-input" type="radio" id="requeue-redirect"
			name="targetMode" value="Redirect" [(ngModel)]="targetMode">
		<label class="form-check-label" for="requeue-redirect">Redirect to…</label>
	</div>

	<div class="form-group ml-4" *ngIf="targetMode === 'Redirect'">
		<input class="form-control" type="email" placeholder="address@ucanr.edu"
			[(ngModel)]="redirectAddress" name="redirectAddress">
	</div>
</mat-dialog-content>

<mat-dialog-actions>
	<button class="btn btn-link" [mat-dialog-close]="undefined">Cancel</button>
	<button class="btn btn-primary" [disabled]="!canSubmit" (click)="submit()">Requeue</button>
</mat-dialog-actions>
